/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APITicket } from './APITicket';
import {
    APITicketFromJSON,
    APITicketFromJSONTyped,
    APITicketToJSON,
} from './APITicket';

/**
 * 
 * @export
 * @interface APIPaginatedTicketList
 */
export interface APIPaginatedTicketList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedTicketList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedTicketList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedTicketList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APITicket>}
     * @memberof APIPaginatedTicketList
     */
    results: Array<APITicket>;
}

/**
 * Check if a given object implements the APIPaginatedTicketList interface.
 */
export function instanceOfAPIPaginatedTicketList(value: object): value is APIPaginatedTicketList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedTicketListFromJSON(json: any): APIPaginatedTicketList {
    return APIPaginatedTicketListFromJSONTyped(json, false);
}

export function APIPaginatedTicketListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedTicketList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APITicketFromJSON)),
    };
}

export function APIPaginatedTicketListToJSON(value?: APIPaginatedTicketList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APITicketToJSON)),
    };
}

